import { request } from 'src/utils/request';

const urls = {
  driverList: '/api/zlbuser/identity/driver/list', // 首页司机人员列表接口
  institutionOperator: '/api/zlbuser/identity/driver/institution/operator', // 获取业务人员下拉列表
  saveDriver: '/api/zlbuser/identity/driver/save', // 手动新增司机
  getJobLevel: '/api/zlbuser/identity/driver/getJobLevel', // 获取人员职级枚举
  changeDriverState: '/api/zlbuser/identity/driver/state', // 启用停用司机
  getDriverDetail: '/api/zlbuser/identity/driver/detail', // 获取司机详情
  deleteDriver: '/api/zlbuser/identity/driver/delete', // 删除司机
  matchingOperator: '/api/zlbuser/identity/driver/institution/matchingOperator', // 匹配内部人员
  getDriverImportRes: '/api/zlbuser/identity/driver/import/result', // 获取excel解析结果
  saveDriverImportRes: '/api/zlbuser/identity/driver/import/save', // 保存导入司机数据
  tempDownload: '/api/zlbuser/identity/driver/template/download', // 下载模板接口
  checkDriver: '/api/zlbuser/identity/driver/check', // checkDriver
};
/**
 * 司机管理-获取业务人员列表接口
 * @param driverList
 * @returns 
 */
export function getDriverList (params) {
  return request(urls.driverList, { method: 'GET', params });
}

/**
 * 司机管理-获取业务人员列表接口
 * @param driverList
 * @returns 
 */
export function getInstitutionOperator (params) {
  return request(urls.institutionOperator, { method: 'GET', params });
}

/**
 * 获取职级下拉枚举
 * @returns 
 */
export function getJobLevel () {
  return request(urls.getJobLevel);
}

/**
 * 修改司机状态
 * @returns 
 */
export function changeDriverState (data) {
  return request(urls.changeDriverState, { method: 'POST', data });
}

/**
 * 获取司机详情
 * @param getDriverDetail
 * @returns 
 */
export function getDriverDetail (params) {
  return request(urls.getDriverDetail, { method: 'GET', params });
}

/**
 * 删除司机
 */
export function deleteDriver (data) {
  return request(urls.deleteDriver, { method: 'POST', data });
}

/**
 * 保存司机
 */
export function saveDriver (data) {
  return request(urls.saveDriver, { method: 'POST', data });
}

/**
 * 匹配内部人员
 * @param matchingOperator
 * @returns 
 */
export function matchingOperator (params) {
  return request(urls.matchingOperator, { method: 'GET', params });
}

/**
 * 获取excel解析结果
 * @param params
 * @returns 
 */
export function getDriverImportRes (params) {
  return request(urls.getDriverImportRes, { method: 'GET', params });
}

/**
 * 保存导入司机数据
 * @param params
 * @returns 
 */
export function saveDriverImportRes (data) {
  return request(urls.saveDriverImportRes, { method: 'POST', data });
}

/**
 * 下载模板链接
 */
export function tempDownload () {
  return request(urls.tempDownload, { method: 'GET' });
}

/**
 * 验证司机身份证 + 手机号
 */
export function checkDriver (data) {
  return request(urls.checkDriver, { method: 'POST', data });
}
